import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_secured/administration/apps/$appId/installation/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/administration/apps/$appId/installation/sites',
      params: { appId: params.appId },
    });
  },
});
